"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateFieldCommandBase = void 0;
var tslib_1 = require("tslib");
var fields_manipulator_1 = require("../../../core/model/manipulators/fields-manipulator");
var command_base_1 = require("../command-base");
var UpdateFieldCommandBase = (function (_super) {
    tslib_1.__extends(UpdateFieldCommandBase, _super);
    function UpdateFieldCommandBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UpdateFieldCommandBase.prototype.canModify = function () {
        return true;
    };
    UpdateFieldCommandBase.updateFields = function (command, updateThisSubDocs, callback, options) {
        command.history.beginTransaction();
        command.control.beginUpdate();
        return command.modelManipulator.field.updateFields(command.control.layoutFormatterManager, command.control.createFieldRequestManager(), new fields_manipulator_1.UpdateFieldsManipulatorParams(updateThisSubDocs, function (result) {
            command.control.endUpdate();
            command.history.endTransaction();
            if (callback)
                callback(result);
        }, options));
    };
    return UpdateFieldCommandBase;
}(command_base_1.CommandBase));
exports.UpdateFieldCommandBase = UpdateFieldCommandBase;
